import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { ReactElement } from 'react'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'

import { APP_ROUTES, PUBLIC_ROUTES, getRoutesNew } from './routes'
import { Modules } from '../pages/Modules/models/Modules.interfaces'
import useAuth from '../modules/auth/hooks/useAuth'
import { getDecodedUrl, getFullPath, getRedirectFingerprint, isSameRedirectUser, clearRedirectUrl } from '../utils/session'
import { useEffect } from 'react'


const PrivateRoutes = ({ allRoutes, currentRole, isLoading, homeRoute }: { allRoutes: Modules[], currentRole: string, isLoading: boolean, homeRoute: string }) => {
  const allRoutesComponent = allRoutes && currentRole ? getRoutesNew([...allRoutes] as Modules[], currentRole as string) as ReactElement[] : [];
  const { isForceChangePassword, currentUser } = useAuth()
  const redirectUrl = getDecodedUrl();
  const storedFingerprint = getRedirectFingerprint();
  const isSameUser = currentUser?.user_id
    ? isSameRedirectUser(storedFingerprint, currentUser.user_id)
    : false;
  const effectiveRedirectUrl = redirectUrl && isSameUser ? redirectUrl : '';
  const location = useLocation();

  // Calculate the target route and ensure it's not the same as current location
  const getTargetRoute = () => {
    const target = effectiveRedirectUrl || homeRoute || '/';
    const currentPath = getFullPath(location.pathname, location.search);
    // Prevent navigation loop by ensuring we don't navigate to the same route
    return target === currentPath ? homeRoute || '/' : target;
  };

  useEffect(() => {
    if (isLoading) return;
    if (redirectUrl && !isSameUser) {
      clearRedirectUrl();
      return;
    }
    if (!effectiveRedirectUrl) return;
    const currentPath = getFullPath(location.pathname, location.search);
    if (currentPath === effectiveRedirectUrl) {
      clearRedirectUrl();
    }
  }, [isLoading, redirectUrl, isSameUser, effectiveRedirectUrl, location.pathname, location.search])
  return (
    <Routes>
      {
        isForceChangePassword ?
          <Route key={APP_ROUTES.ForceChangePassword} path='*' element={<Navigate to={`/${APP_ROUTES.ForceChangePassword}`} replace />} />
          :
          <Route key={'masterlayout'} element={<MasterLayout />}>
            <Route key={'dashboard-redirect'} path='auth/*' element={<Navigate to={getTargetRoute()} replace />} />
            {allRoutesComponent}
            <Route index element={<Navigate to={getTargetRoute()} replace />} />
            <Route path='*' element={<Navigate to={`/${PUBLIC_ROUTES.ERROR_404}`} replace />} />
          </Route>
      }

    </Routes>
  )

}


export { PrivateRoutes }
